import React from 'react';
import cn from 'classnames';

import { CalendarIcon } from '../../icons/CalendarIcon';

interface CustomButtonProps {
  value: string;
  placeholder?: string;
  error?: string;
}

export const CustomButton = (props: CustomButtonProps) => {
  const { value, placeholder, error } = props;

  return (
    <button
      {...props}
      type={'button'}
      className={cn(
        'flex justify-between w-full',
        'flex-grow items-center',
        'border-1 border-blue-gray-300 dark:border-gray-700 bg-base-white rounded-lg',
        'text-sm',
        'overflow-hidden py-2 px-14px',
        'bg-white dark:bg-gray-900 shadow-small1 mt-1 leading-4',
        { 'text-blue-gray-500': value === '' },
        {
          'border-red-400 rounded-none shadow-none': !!error
        },
        {
          'text-red-600': !!error && value !== ''
        }
      )}
    >
      {value ? value : placeholder}
      <CalendarIcon />
    </button>
  );
};
